module.exports = __webpack_public_path__ + "static/media/xpressor_bg.530ce1af.png";